import { FC, useEffect, useRef, useState } from 'react';

import 'shared/common/assets/colors.css';

import { withCommonProviders } from '../../../common/containers/CommonContextProviders';
import { IApplicationCommonRootComponentProps } from '../../../common/types/applicationRootComponent';
import { FormContainer } from '../FormContainers';
import { ListingContainer } from '../ListingContainer';
import { ModalContainer } from '../ModalContainer';
import { UnfinishedAnketaModalContainer } from '../UnfinishedAnketaModalContainer';
import { LoginWidgetMicrofrontend } from '../../microfrontends/LoginWidgetMicrofrontend';
import { useSelector } from 'react-redux';
import { selectIsOpenAuthorizationModal } from '../../selectors/modal';
import { useGetOffers } from '../../hooks/useGetOffers';

import * as styles from './styles.css';
import { ETestIds } from '../../constants';
import { useScrollStopOnView } from '../../../common/hooks/useScrollStopOnView/useScrollStopOnView';
import { useTracking } from 'shared/mortgageMiniCalculator/utils/tracking/useTracking';

export const MortgageMiniCalculatorApp: FC<IApplicationCommonRootComponentProps> = withCommonProviders(() => {
  const isAuthorizedModalOpen = useSelector(selectIsOpenAuthorizationModal);
  /** После первого открытия держим хост виджета смонтированным, чтобы при закрытии передать `isWidgetOpen: false` и не рвать портал/оверлей без cleanup у MF. */
  const [keepLoginWidgetMounted, setKeepLoginWidgetMounted] = useState(false);
  const { fetchOffers, ...listingProps } = useGetOffers();
  const { trackScrollAndStopOnBlock } = useTracking();
  const refBlock = useRef<HTMLDivElement | null>(null);

  useScrollStopOnView(refBlock, {
    onStop: () => {
      trackScrollAndStopOnBlock();
    },
    threshold: 0.3,
  });

  useEffect(() => {
    if (isAuthorizedModalOpen) {
      setKeepLoginWidgetMounted(true);
    }
  }, [isAuthorizedModalOpen]);

  return (
    <div ref={refBlock} className={styles['root']} data-testid={ETestIds.CalculatorLayout}>
      <FormContainer fetchOffers={fetchOffers} />
      <ListingContainer {...listingProps} />
      <ModalContainer />
      <UnfinishedAnketaModalContainer />
      {keepLoginWidgetMounted && <LoginWidgetMicrofrontend />}
    </div>
  );
});
